/* ============================================================
   О федерации: миссия, ценности, команда, документы.
   ============================================================ */
import { useFedStore, useL } from '../store';
import { useFedContent, uploadUrl, federationAbout } from '../content';
import { VALUES } from '../data';
import { Ic } from '../icons';
import { Rv, Eyebrow } from '../ui';

export default function FedAbout() {
  const { lang } = useFedStore();
  const L = useL();
  const team = useFedContent((s) => s.team);
  const docs = useFedContent((s) => s.docs);
  const settings = useFedContent((s) => s.settings);

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 72px' }}>
      <Rv className="max-w-[760px]" style={{ marginBottom: 44 }}>
        <Eyebrow style={{ marginBottom: 12 }}>{settings.region || L.heroRegion}</Eyebrow>
        <h1 style={{ fontSize: 'clamp(38px,6vw,64px)' }}>{settings.name || L.ab_h1}</h1>
        <p className="text-fg-soft" style={{ marginTop: 16, fontSize: 18, lineHeight: 1.6 }}>{federationAbout(settings, lang, L.ab_lead)}</p>
      </Rv>

      <div className="fed-split-2" style={{ marginBottom: 44 }}>
        <Rv className="rounded-[18px]" style={{ padding: 30, background: 'linear-gradient(160deg,rgba(225,18,23,.1),var(--fed-surface) 55%)', border: '1px solid var(--fed-line-accent)' }}>
          <h2 style={{ fontSize: 24, marginBottom: 14 }}>{L.ab_mission_t}</h2>
          <p className="text-fg-soft" style={{ fontSize: 15.5, lineHeight: 1.7 }}>{L.ab_mission}</p>
        </Rv>
        <Rv delay={0.08} className="flex flex-col gap-3">
          {VALUES.map((v) => (
            <div key={v.icon} className="flex gap-[15px] items-start rounded-[14px] bg-surface border border-line" style={{ padding: 18 }}>
              <Ic name={v.icon} size={26} color="var(--fed-accent-bright)" className="flex-shrink-0" />
              <div>
                <div className="font-display font-semibold text-fg" style={{ fontSize: 17 }}>{v['t_' + lang]}</div>
                <p className="text-fg-muted" style={{ fontSize: 13.5, lineHeight: 1.55, marginTop: 5 }}>{v['d_' + lang]}</p>
              </div>
            </div>
          ))}
        </Rv>
      </div>

      {team.length > 0 && (<>
      <Rv style={{ marginBottom: 20 }}><h2 style={{ fontSize: 'clamp(24px,3.4vw,34px)' }}>{L.ab_team_t}</h2></Rv>
      <div className="fed-about-team-grid">
        {team.map((m, i) => (
          <Rv key={m.id || m.mono} delay={(i % 3) * 0.06} className="fed-about-team-card flex flex-col items-center justify-center text-center gap-3 rounded-2xl border border-line" style={{ background: 'linear-gradient(160deg,var(--fed-surface-2),var(--fed-surface))' }}>
            <div
              className="rounded-full flex items-center justify-center font-display font-bold text-white overflow-hidden"
              style={{ width: 74, height: 74, fontSize: 24, background: 'linear-gradient(140deg,var(--fed-accent),var(--fed-accent-deep))', boxShadow: '0 12px 30px -12px var(--fed-accent-glow)' }}
            >
              {m.photo
                ? <img src={uploadUrl(m.photo)} alt="" className="w-full h-full" style={{ objectFit: 'cover' }} />
                : (m.mono || '').slice(0, 3)}
            </div>
            <div>
              <div className="font-display font-semibold text-fg" style={{ fontSize: 18 }}>{m['name_' + lang]}</div>
              <div className="text-fg-muted" style={{ fontSize: 12.5, marginTop: 4 }}>{m['role_' + lang]}</div>
            </div>
          </Rv>
        ))}
      </div>
      </>)}

      {docs.length > 0 && (<>
      <Rv style={{ marginBottom: 20 }}><h2 style={{ fontSize: 'clamp(24px,3.4vw,34px)' }}>{L.ab_docs_t}</h2></Rv>
      <div className="grid gap-3" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))' }}>
        {docs.map((d) => (
          <Rv
            key={d.id || d.name_ru}
            as="a"
            href={uploadUrl(d.file) || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="fed-hover-lift flex items-center gap-3.5 rounded-[13px] bg-surface border border-line no-underline"
            style={{ padding: '16px 18px' }}
          >
            <span className="flex-shrink-0 flex items-center justify-center rounded-[10px] text-accent-bright" style={{ width: 42, height: 42, background: 'rgba(225,18,23,.09)', border: '1px solid var(--fed-line-accent)' }}>
              <Ic name="doc" size={18} sw={1.8} />
            </span>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-fg" style={{ fontSize: 14.5 }}>{d['name_' + lang]}</div>
              <div className="font-mono text-fg-faint" style={{ fontSize: 11, marginTop: 2 }}>{d.size}</div>
            </div>
            <span className="font-display font-semibold uppercase text-accent-bright" style={{ fontSize: 12 }}>{L.ab_download}</span>
          </Rv>
        ))}
      </div>
      </>)}
    </div>
  );
}
